export default __webpack_public_path__ + "static/media/hallowkitty.9188c2d1.jpg";